import React, { Component, Fragment } from 'react'

class AppBarSEO extends Component {
    render() {
        const {meta_title, meta_description, meta_keywords} = this.props;
        return (
            <Fragment>
                <div className={`boxColor ${
                meta_title.length > 0 ?
                meta_title.length > 9 ?
                meta_title.length > 29 ? 
                meta_title.length > 48 ? 
                meta_title.length > 54 ?
                meta_title.length > 65 ? 
                meta_title.length > 75 ? 
                'danger' 
              : 'danger'
              : 'success'
              : 'success'
              :  'success'
              :  'warning'
              :  'danger'
              :  'bgDark'
                }`} />
              <span>
                Tiêu đề: {meta_title.length} kí tự (
                { meta_title.length > 0 ?
                  meta_title.length > 9 ?
                  meta_title.length > 29 ? 
                  meta_title.length > 48 ? 
                  meta_title.length > 54 ?
                  meta_title.length > 65 ? 
                  meta_title.length > 75 ? 
                  <span className="textDanger">Tiêu đề quá dài</span> 
                : <span className="textDanger">Tiêu đề dài</span>
                : <span className="textSuccess">Tuyệt vời</span>
                : <span className="textSuccess">Rất tốt</span>
                : <span className="textSuccess">Tốt</span>
                : <span className="textWarning">Ngắn</span>
                : <span className="textDanger">Quá ngắn</span>
                : <span className="textDark">Không xác định</span>
                }
                )
              </span>
              <span style={{width: 30}} />
              <div className={`boxColor ${
                meta_description.length > 0 ?
                meta_description.length > 75 ?
                meta_description.length > 100 ?
                meta_description.length > 154 ?
                meta_description.length > 165 ?
                meta_description.length > 175 ?
                'danger'
              : 'danger'
              : 'success'
              : 'success'
              : 'warning'
              : 'danger'
              : 'bgDark'
                }`} />
              <span>
                Mô tả: {meta_description.length} kí tự (
                { meta_description.length > 0 ?
                  meta_description.length > 75 ?
                  meta_description.length > 119 ?
                  meta_description.length > 154 ?
                  meta_description.length > 165 ?
                  meta_description.length > 175 ?
                  <span className="textDanger">Quá dài</span>
                : <span className="textDanger">Dài</span>
                : <span className="textSuccess">Tuyệt vời</span>
                : <span className="textSuccess">Tốt</span>
                : <span className="textWarning">Ngắn</span>
                : <span className="textDanger">Quá ngắn</span>
                : <span className="textDark">Không xác định</span>
                }
                )
              </span>
              <span style={{width: 30}} />
              <div className={`boxColor ${meta_keywords.split(',').length-1 > 0 ? 'success' : 'bgDark'}`} />
              <span>Từ khoá: {meta_keywords.split(',').length-1} từ</span>
            </Fragment>
        )
    }
}

export default AppBarSEO
